import ExpandableComponent from './ExpandableComponent';

export default ExpandableComponent;
